/**
 * DiscoveryBanner 스타일
 * @description 누르는 자리가 비율 상자를 **채워야** 한다. `ImageBanner` 는 한 장을 `Media` 로
 *   감싸 비율만 잡아 주고, 그 안을 채우는 것은 내용의 몫이다 — 링크가 네 변을 잡는다.
 *
 *   배너는 **그림 한 장**이다. 앱 시안이 그렇고(글자는 그림에 구워져 온다), 위에 글자를
 *   얹어 봤더니 그림을 가렸다. 제목은 링크의 읽어주는 이름으로만 남는다.
 *
 *   보이는 장의 그림은 머무는 동안 천천히 다가온다(`fw-kenburns`, globals.css). 상자가
 *   잘라 주므로 배너 크기는 그대로다. 움직임을 줄인 설정에서는 없다.
 */
export const discoveryBannerStyles = {
  page: "absolute inset-0 block [&_img]:origin-center motion-safe:group-data-[active=true]/page:[&_img]:animate-[fw-kenburns_12s_ease-out_forwards]",
};
